/** @file puppet.rename: renames the document's puppet. */
import type { CommandDef } from '../apply/commandDef';
import { readInput } from '../validate/readInput';

/** `puppet.rename { name }` → `{ name }`; inverse: rename back. */
export const puppetRenameCommand: CommandDef<'puppet.rename'> = {
  name: 'puppet.rename',
  /** Checks the raw input (VALIDATION under the input path). */
  validate: (input, path) => ({ name: readInput(input, path, ['name']).str('name') }),
  /** Applies the command to the draft and returns its result and inverse. */
  apply: (draft, input) => {
    const prev = draft.puppet.name;
    draft.puppet.name = input.name;
    return { result: { name: input.name }, warnings: [], inverse: [{ name: 'puppet.rename', input: { name: prev } }] };
  },
};
